export default "__VITE_ASSET__DhOaJzFz__"